import { Injectable } from '@angular/core';
import * as _ from 'lodash-es';
import { TranslationService } from 'src/app/core/translation/translation.service';

import { LegacyTaskStatus } from './legacy-task';

@Injectable({
    providedIn: 'root'
})
export class LegacyStatusService {
    private statuses: { label: LegacyTaskStatus; displayValue: string }[];
    // explicitly typing to any as exact typing cannot be imported through 'lodash-es'
    private statusLabelToDisplayValue: any;

    constructor(translate: TranslationService) {
        this.statuses = [
            { label: LegacyTaskStatus.NEW, displayValue: translate.instant('NEW') },
            { label: LegacyTaskStatus.IN_PROGRESS, displayValue: translate.instant('IN_PROGRESS') },
            { label: LegacyTaskStatus.BLOCKED, displayValue: translate.instant('TC.Common.Status.Waiting') },
            { label: LegacyTaskStatus.RESOLVED, displayValue: translate.instant('RESOLVED') },
            { label: LegacyTaskStatus.CLOSED, displayValue: translate.instant('CLOSED') }
        ];

        this.statusLabelToDisplayValue = _.keyBy(this.statuses, 'label');
    }

    getStatuses(): { label: LegacyTaskStatus; displayValue: string }[] {
        return this.statuses;
    }

    labelToDisplayValue(label: LegacyTaskStatus): string {
        return this.statusLabelToDisplayValue[label] ? this.statusLabelToDisplayValue[label].displayValue : null;
    }
}
